import React, { useLayoutEffect, useRef } from "react";

// Keeps the bar where it is unless the position moved outside the current sentence.
const getCurrentFraction = (barElement, audio) => {
  const trackWidth = barElement.parentElement.getBoundingClientRect().width;
  const fraction = trackWidth ? barElement.getBoundingClientRect().width / trackWidth : 0;
  return fraction >= audio.progressStart && fraction <= audio.progressEnd ? fraction : audio.progressStart;
};

function StoryAudioProgress({ audio }) {
  const barRef = useRef(null);

  useLayoutEffect(() => {
    const bar = barRef.current;
    if (audio.isPlaying) {
      bar.style.transition = "none";
      bar.style.width = `${getCurrentFraction(bar, audio) * 100}%`;
      bar.getBoundingClientRect();
      bar.style.transition = `width ${audio.progressDurationMs}ms linear`;
      bar.style.width = `${audio.progressEnd * 100}%`;
      return;
    }
    const pausedFraction = getCurrentFraction(bar, audio);
    bar.style.transition = "none";
    bar.style.width = `${pausedFraction * 100}%`;
  }, [audio.isPlaying, audio.progressEnd, audio.progressDurationMs]);

  return (
    <div className="story-audio-progress">
      <div data-testid="story-audio-progress" ref={barRef} />
    </div>
  );
}

export default function StoryAudioBar({ audio, sentenceCount, onOpenSettings, onToggle }) {
  return (
    <div className="story-audio-bar" data-testid="story-audio-bar">
      <div className="story-audio-bar-content">
        <StoryAudioProgress audio={audio} />
        <button aria-label={audio.isPlaying ? "Pause audio" : "Play audio"} className="story-audio-toggle" type="button" onClick={onToggle}>
          <span className={`fa fa-${audio.isPlaying ? "pause" : "play"}`} />
        </button>
        <span className="story-audio-position">{audio.sentenceIndex + 1} / {sentenceCount}</span>
        <button aria-label="Rewind" className="story-icon-button" type="button" onClick={audio.rewind}>
          <span className="fa fa-step-backward" />
        </button>
        <button aria-label="Audio settings" className="story-icon-button" type="button" onClick={onOpenSettings}>
          <span className="fa fa-cog" />
        </button>
      </div>
    </div>
  );
}
